export default {
  list: [],
  newActionsNumber: 0,
}
